export default __webpack_public_path__ + "images/phi_v2_fff600.png";